import st from "@/styles/Ui.module.scss";
// import React from "react";

const DividerSimple = () => {
    return (
        <div className={st.divider_simple}/>
    )
}

export default DividerSimple